import AbstractEntity from "../AbstractEntity";

export default class InformationMessage extends AbstractEntity {
    static RECIPIENT_TYPE_ENTREPRENEUR = 0;
    static RECIPIENT_TYPE_ARTISAN = 1;

    _id;
    _content;
    _recipientType;
    _createdAt;

    getId() {
        return this._id;
    }

    getContent() {
        return this._content;
    }

    getRecipientType() {
        return this._recipientType;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getClassName() {
        return "information_message";
    }
}